export class Shoes {
  constructor(public name: string, public price: number, public size: number){}
}



// WEBPACK FOOTER //
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/shoes.model.ts